import { FINANCIAL_INFO_VIEWS_PATHS } from '../tabs/financialInfo/FinancialInfo.constants';

export const FinancialInfoViewName = {
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: 'Liabilities',
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: 'Income & Employment',
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: 'Assets',
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: 'REO',
};
